export default __webpack_public_path__ + "static/media/FlyingFrog30.adfb88ec.png";